import staticData from '../config/staticData'
import { getRequest, urlBuilder } from 'tfs.front-end-utils/requests'

import formatErrors from './errors/formatErrors'
import getAuthenticationHeaders from './requests/generateAuthorizationHeaders'

import { customTourOperatorParameters } from './tourOperators'
import { formatFlightDetails } from './format'

/**
 * Add the flightDetails to each flight
 * @param {Object} flight
 * @param {Number} index
 * @param {Object} flightInfoResponses
 * @returns {Object}
 */
const addFlightDetails = (flight, index, flightInfoResponses) => {
  const { sta, std } = flightInfoResponses[index]
  const flightInfoInput = { arrival: sta, departure: std }
  const flightInfo = formatFlightDetails(flightInfoInput)

  return {
    ...flight,
    flightInfo,
  }
}

/**
 * Make the request for the flight information
 * @param {Object} flight
 * @returns {Promise}
 */
const requestFlightInfo = async flight => {
  const {
    endpoints: {
      flight: { url, headers },
    },
  } = staticData
  const authHeaders = await getAuthenticationHeaders(headers)

  const fixedUrl = url.endsWith('/') ? url : `${url}/`
  const reqUrl = `${fixedUrl}${flight.flightId}`
  const params = customTourOperatorParameters()
  const requestUrl = urlBuilder(reqUrl, params)

  return getRequest(
    requestUrl,
    { headers: { ...headers, ...authHeaders } },
    {},
    formatErrors
  )
}

/**
 * Add the flightDetails to a flight
 * @param {Object} flight
 * @returns {Promise}
 */
export const addFlightDetailsToFlights = async flight => {
  const flightInfoRequests = flight.items.map(requestFlightInfo)

  try {
    const flightInfoResponses = await Promise.all(flightInfoRequests)
    const items = flight.items.map((flight, index) =>
      addFlightDetails(flight, index, flightInfoResponses)
    )

    return { ...flight, items }
  } catch (err) {
    return flight
  }
}
